<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'DIALOG.TAG_LIST.MARK_SETTING' | translate }}</div>
                <div class="tools"></div>
            </div>
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a class="nav-link active" [ngClass]="{'active': switchTab === 'list'}" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true" (click)="switchTabs('list')">{{ 'DIALOG.TAG_LIST.MARK_LIST' | translate }}</a>
                      <a class="nav-link" [ngClass]="{'active': switchTab === 'actions'}"  id="nav-actions-tab"  data-toggle="tab" href="#nav-actions" role="tab" aria-controls="nav-actions" aria-selected="true" (click)="switchTabs('actions')">{{ 'DIALOG.TAG_LIST.CREATE_EDIT_MARKS' | translate }}</a>
                    </div>
                </nav>

                    <div class="tab-content" id="nav-tabContent">

                        <!-- LIST -->
                        <!-- <div class="tab-pane fade active" id="nav-list"  [ngClass]="{'show active': switchTab === 'list'}" role="tabpanel" aria-labelledby="nav-list-tab">

                            <app-tags-list [tagsIdsFromAddInfo]="tagsIDs"></app-tags-list>

                        </div> -->

                        <!-- CREATE/EDIT -->
                        <!-- <div class="tab-pane fade" id="nav-actions" [ngClass]="{'show active': switchTab === 'actions'}" role="tabpanel" aria-labelledby="nav-actions-tab">

                            <app-tags-actions></app-tags-actions>

                        </div> -->

                </div>

            </div>
        </div>

    </div>
</div>